import { loadQuery, type PreloadedQuery } from 'react-relay';
import {
	createResource,
	type RouterDataContext,
	type ResourceStoreContext,
} from '@atlassian/react-resource-router';
// eslint-disable-next-line jira/import-whitelist
import getRelayEnvironment from '@atlassian/jira-relay-environment/src/index.tsx';
import QUERY, {
	type knowledgeHubBrowseAllArticlesKBTypeCheckerQuery,
} from '@atlassian/jira-relay/src/__generated__/knowledgeHubBrowseAllArticlesKBTypeCheckerQuery.graphql';
import { consumeDependency } from '@atlassian/jira-router-resources-utils/src/utils/consume-dependency/index.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import { projectIdResource } from '../project-id/index.tsx';

// eslint-disable-next-line jira/router/no-daisy-chaining-resources
export const knowledgeHubBrowseAllArticlesKBTypeCheckerResource = createResource<
	PreloadedQuery<knowledgeHubBrowseAllArticlesKBTypeCheckerQuery>
>({
	type: 'KNOWLEDGE_HUB_BROWSE_ALL_ARTICLES_KB_TYPE_CHECKER',
	depends: [projectIdResource.type],
	getKey: (routerContext) => {
		const projectKey = routerContext.match.params.projectKey;
		return `knowledge-hub-kb-type-checker-${projectKey}`;
	},
	getData: async (dataContext: RouterDataContext, { tenantContext }: ResourceStoreContext) => {
		const { cloudId } = tenantContext;
		const projectKey = dataContext.match.params.projectKey;
		// Use shared project ID resource
		const { dependencies } = dataContext;
		const projectData = await consumeDependency<{ id: string }>(
			dependencies,
			projectIdResource.type,
		);
		if (!projectData?.id) {
			throw new Error(`Failed to get project ID for project key: ${projectKey}`);
		}

		// Construct container using projectId
		const container = `ari:cloud:jira:${cloudId}:project/${projectData.id}`;

		// Use loadQuery to create the preloaded query and return it
		const queryReference = loadQuery<knowledgeHubBrowseAllArticlesKBTypeCheckerQuery>(
			getRelayEnvironment(),
			QUERY,
			{
				cloudId,
				container,
				isAgentKbEnabled: fg('enable_jsm_agent_kb'),
			},
		);

		return queryReference;
	},
	isBrowserOnly: true,
});
